import { NgModule, PlatformRef } from '@angular/core';
import {
  NodeModule,
  NodeHttpModule,
  NodeJsonpModule,
  NodePlatform,
  platformNodeDynamic
} from '../lib';

export type NodePlatformRef = PlatformRef & NodePlatform;

export function platformUniversalDynamic (extraProviders?: any[]): NodePlatformRef {
  const platform: NodePlatformRef = platformNodeDynamic(extraProviders);
  return platform;
};


export class UniversalModule {
  static withConfig(config = {}): {ngModule: UniversalModule, providers: any[]} {
    var {providers} = NodeModule.withConfig(config);
    return {
      ngModule: UniversalModule,
      providers: providers || []
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  exports: [
    NodeModule,
    NodeHttpModule,
    NodeJsonpModule
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
